import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = ["category", "list", "site", "priority"];

    SITES = [];

    SELECTED_PRIORITY = "All";
    SELECTED_CATEGORY = "All";

    connect()
    {
        if(this.siteTargets.length == 0) return;

        this.SITES = this.siteTargets.map(target => target.cloneNode(true));

        this.priorityTargets.forEach(priority => priority.addEventListener("click", e =>
        {
            this.priorityTargets.forEach(pri => pri.classList.remove("selected"));
            priority.classList.add("selected");

            this.SELECTED_PRIORITY = priority.dataset["priority"];

            this.filterAndReplace()

        }))

        this.categoryTargets.forEach(category => category.addEventListener("click", e =>
        {
            this.categoryTargets.forEach(cat => cat.classList.remove("selected"));
            category.classList.add("selected");

            this.SELECTED_CATEGORY = category.dataset["code"];

            this.filterAndReplace();
        }))
    }

    filterAndReplace()
    {
        let filtered = this.SELECTED_PRIORITY == "All" ? this.SITES :
            this.SITES.filter(site => site.dataset["priority"] == this.SELECTED_PRIORITY);

        filtered = this.SELECTED_CATEGORY == "All" ? filtered :
            filtered.filter(site => site.dataset["code"].toLowerCase() == this.SELECTED_CATEGORY.toLowerCase());

        let visibleCodes = [... new Set(filtered.map(site => site.dataset["code"]))]


        this.listTarget.firstElementChild.classList.add("hidden");

        let div = document.createElement("div");
        div.append(...filtered);
        div.classList.add("list", "mx-4");

        this.listTarget.replaceChild(div, this.listTarget.firstElementChild)
    }
}